// extracted by mini-css-extract-plugin
module.exports = {"header":"PromoRollCardKuper_header__lXPQ4","button":"PromoRollCardKuper_button__jSn2U"};